import React, { useEffect, useState  } from 'react'
import {
	PAYMENT_TYPES_SELECT_ITEMS,
	SCI_SELECT_ITEMS,
	ACCOUNTING_IDENTIFIER_SELECT_ITEMS,
} from '../../constants'
import { Dropdown } from '../../common/DropDown'
import {
	validateAlphaIfPresent,
	validateAlphaNumericIfPresent,
	hasError,
	removeError,
	validateNumericIfPresent,
	validateFieldLengthIfPresent,
	handleHsCode,
	validateDecimalIfPresent,
	validateRequired,
	validateSuppleCusInfoIfPresent,
} from '../CaptureAWB/captureAwbUtils'

import {
	
} from './CaptureHawbValidations'
import plusIcon from '../../assets/images/plusBlue.svg'
import deleteIcon from '../../assets/images/delete_icon_red.png'
import { useTranslation } from 'react-i18next'
import { CommonDropDown } from '../../common/Resusable/CommonDropDown'
import CommonInput from '../../common/Resusable/CommonInput'
const CustomsDetails = ({ hawbResponseDetails, setHawbResponseDetails,
	awbChargeDeclaration,
	setAwbChargeDeclaration,
	customsInformationDetails,
	setCustomsInformationDetails,
	otherCustomsDetails,
	setOtherCustomsDetails,
	error, setError,
	awbDetailsData,
	validationRule,
	shipmentDetails,
}) => {
	
	const { t } = useTranslation(['labels', 'errors'])
	const [isHsCodeRequired, setIsHsCodeRequired] = useState(true);
	useEffect(() => {
		if (customsInformationDetails) {
			setCustomsInformationDetails(customsInformationDetails)
		}
	}, [customsInformationDetails])

	useEffect(() => {
		if (awbChargeDeclaration) {
			setAwbChargeDeclaration(awbChargeDeclaration)
		}
	}, [awbChargeDeclaration])

    useEffect(() => {
		if (otherCustomsDetails) {
			setOtherCustomsDetails(otherCustomsDetails)
		}
	}, [otherCustomsDetails])


	useEffect(() => {}, [])
	const handleAddCustomsInfo = () => {
		const customsInfo = {
			informationIdentifier: '',
			customsInformationIdentifier: '',
			supplementaryCustomsControlInformation: '',
			countryCode: '',
			isNew: true,
		}
		let customsInformationDetailsTemp = [...customsInformationDetails]
		customsInformationDetailsTemp.push(customsInfo)
		setCustomsInformationDetails(customsInformationDetailsTemp)
	}

	const handleDeleteAction = (e, index) => {
		const customsInformationDetailsTemp = customsInformationDetails?.filter(
			(itemDetail, curr) => {
				return index !== curr
			}
		)
		setCustomsInformationDetails(customsInformationDetailsTemp)
	}

	var trimDecimalValue = function( val, decimals ) {
		if ( parseFloat( val ) ) {
			var numeric_string = String(val);
			var parts = numeric_string?.split( '.', 2);
			if ( parts[1] && parts[1].length > decimals ) {
				let slicedString = parts[0]+'.'+parts[1].slice(0,3)
				return slicedString?.slice(0,13)
			}
			else {
				if(val % 1 !== 0){
					let numberString = String(val)
					return numberString?.slice(0,13)
				}
				else{
					let numberString = String(val)
					return numberString?.slice(0,12)
				}
			}
		}
	}

	useEffect(() => {
		if (awbDetailsData || hawbResponseDetails ) {
			checkHsCodeRequirement();
		}
	}, [awbDetailsData, shipmentDetails?.destination]);


	const checkHsCodeRequirement = () => {
		if (validationRule && validationRule.length > 0) {
			const isDestinationInAwbDetails = awbDetailsData?.awbDetails?.awbRoutingDetails?.awbRouting?.some(
				(routingDetail) =>
					validationRule?.some(
						(rule) => rule?.airports?.includes(routingDetail?.destination)
					)
			);

			const isDestinationInHawbDetails = validationRule?.some(
				(rule) => rule?.airports?.includes(shipmentDetails?.destination?.code)
			);

			const isHsCodeRequired = isDestinationInAwbDetails || isDestinationInHawbDetails;

			setIsHsCodeRequired(isHsCodeRequired);
		}
	};
	return (
		<div className='portal-row cutom-details'>
			
				<div className='portal-row hawb-othercustoms-details-section'>
					<div className='shipping-deparr-row'>
						<CommonDropDown
							id='sci'
							value={otherCustomsDetails ? otherCustomsDetails?.sci : ''}
							options={SCI_SELECT_ITEMS}
							label='SCI'
							onChange={(e) => {
								const sciVal = e.target.value
								setOtherCustomsDetails({
									...otherCustomsDetails,
									sci: sciVal,
								})
							}}
							ariaInvalid={hasError('sci', error)}
							onFocus={(e) => {
								removeError(e, setError)
							}}
						/>
						{/* <div className='col-6 col-lg-2 form-item'>
							<Dropdown
								id='sci'
								value={otherCustomsDetails ? otherCustomsDetails.sci : ''}
								options={SCI_SELECT_ITEMS}
								label='SCI'
								onChange={(e) => {
									const sciVal = e.target.value
									setOtherCustomsDetails({
										...otherCustomsDetails,
										sci: sciVal,
									})
									//validateRequired(e.target.value, setError, 'sci')
								}}
								ariaInvalid={hasError('sci', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							></Dropdown>
							<span className='form-item__error'>
								{error && error['sci'] ? error['sci'] : ''}
							</span>
						</div> */}


						<div
							className={`form-group ${hasError('dvCarriage', error) ? "red-border" : ""
								}`}
						>
							<CommonInput
								id='dvCarriage'
								type='number'
								label={`${t('COMMON.DV_CARRIAGE')} (${awbChargeDeclaration?.awbCurrencyCode})`}
								maxLength={awbChargeDeclaration && awbChargeDeclaration?.declaredValueForCarriage % 1 === 0 ? '12' : '13'}
								value={awbChargeDeclaration ? awbChargeDeclaration?.declaredValueForCarriage : ''}
								onChange={(e) => {
									let trimmedValue = trimDecimalValue(e.target.value, 2)
									setAwbChargeDeclaration({
										...awbChargeDeclaration,
										declaredValueForCarriage: trimmedValue,
									})
								}}
								onBlur={(e) => {
									validateDecimalIfPresent(
										e.target.value,
										setError,
										'dvCarriage'
									)
								}}
								aria-invalid={hasError('dvCarriage', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
								error={error && error['dvCarriage']
									? t(error['dvCarriage'], { ns: 'errors' })
									: ''}
							/>
						</div>

						{/* <div
							className='col-6 col-lg-2 form-item form-item--text'
							data-module='molecules/form-item/FormItem'
						>
							<label className='form-item__label'>{`${t(
								'COMMON.DV_CARRIAGE'
							)}
									(${awbChargeDeclaration.awbCurrencyCode})`}</label>
							<input
								id='dvCarriage'
								type='number'
								className='form-item__field'
								maxLength={awbChargeDeclaration && awbChargeDeclaration.declaredValueForCarriage % 1 === 0 ? '12' : '13'}
								placeholder='DV carriage'
								value={awbChargeDeclaration ? awbChargeDeclaration.declaredValueForCarriage : ''}
								onChange={(e) => {
									let trimmedValue = trimDecimalValue(e.target.value, 2)
									setAwbChargeDeclaration({
										...awbChargeDeclaration,
										declaredValueForCarriage: trimmedValue,
									})
								}}
								onBlur={(e) => {
									validateDecimalIfPresent(
										e.target.value,
										setError,
										'dvCarriage'
									)
								}}
								aria-invalid={hasError('dvCarriage', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							/>
							<span className='form-item__error'>
								{error && error['dvCarriage']
									? t(error['dvCarriage'], { ns: 'errors' })
									: ''}
							</span>
						</div> */}

					</div>

					<div className='shipping-deparr-row'>


						<div
							className={`form-group ${hasError('hsCode', error) ? "red-border" : ""
								}`}
						>
							<CommonInput
								id='hsCode'
								type='text'
								label={isHsCodeRequired ? t('CAPTURE_AWB.HS_CODE_MANDATORY') : t('CAPTURE_AWB.HS_CODE')}
								maxLength='100'
								value={otherCustomsDetails && otherCustomsDetails?.hccs ? otherCustomsDetails?.hccs?.toUpperCase() : ''}
								onChange={(e) => {
									const hsCodeVal = e.target.value
									setOtherCustomsDetails({
										...otherCustomsDetails,
										hccs: hsCodeVal
											? hsCodeVal?.split(' ')?.join('')?.toUpperCase()
											: '',
									})
								}}
								onBlur={(e) => {
									// const isValid = validateRequired(e.target.value, setError, 'hsCode', 'HS code')
									// if (isValid) {
									// 	handleHsCode(e.target.value, setError)
									// }
									handleHsCode(e.target.value, setError, isHsCodeRequired)
								}}
								aria-invalid={hasError('hsCode', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
								error={error && error['hsCode']
									? t(error['hsCode'], { ns: 'errors' })
									: ''}
							/>
						</div>

						{/* <div
							className='col-6 col-lg-2 mt-md-2 mt-lg-0 form-item form-item--text'
							data-module='molecules/form-item/FormItem'
						>
							<label className='form-item__label'>
								{isHsCodeRequired ? t('CAPTURE_AWB.HS_CODE_MANDATORY') : t('CAPTURE_AWB.HS_CODE')}
							</label>
							<input
								id='hsCode'
								type='text'
								className='form-item__field'
								maxLength='100'
								value={otherCustomsDetails && otherCustomsDetails.hccs ? otherCustomsDetails.hccs.toUpperCase() : ''}
								onChange={(e) => {
									const hsCodeVal = e.target.value
									setOtherCustomsDetails({
										...otherCustomsDetails,
										hccs: hsCodeVal
											? hsCodeVal.split(' ').join('')?.toUpperCase()
											: '',
									})
								}}
								onBlur={(e) => {
									// const isValid = validateRequired(e.target.value, setError, 'hsCode', 'HS code')
									// if (isValid) {
									// 	handleHsCode(e.target.value, setError)
									// }
									handleHsCode(e.target.value, setError, isHsCodeRequired)
								}}
								aria-invalid={hasError('hsCode', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
							/>
							<span className='form-item__error'>
								{error && error['hsCode']
									? t(error['hsCode'], { ns: 'errors' })
									: ''}
							</span>
						</div> */}
					</div>
				</div>
					
					
					<div className='portal-row'>
						<div className='portal-col hawb-customs-info-section-wrapper'>	
									<h5 className='section-sub-heading mb-0 mt-0'>
										{t('CAPTURE_AWB.CUST_INFO')}
									</h5>
							{customsInformationDetails && customsInformationDetails?.length ? (
								customsInformationDetails?.map((info, index) => (
									<div className='portal-row hawb-customs-info-section'>
									  <div className='shipping-deparr-row'>

											<div
												className={`form-group ${hasError(`isoCountryCode${index}`, error) ? "red-border" : ""
													}`}
											>
												<CommonInput
													id={`isoCountryCode${index}`}
													type='text'
													maxLength='2'
                                                    label={t('CAPTURE_AWB.ISO_CNTRY_CODE')}
													value={info.countryCode ? info.countryCode.toUpperCase() : ''}
													onChange={(e) => {
														let customsInformationDetailsTemp = [...customsInformationDetails]
														const val = e.target.value
														customsInformationDetailsTemp[index].countryCode =
															val && val.trim() !== '' ? val.toUpperCase() : val
														setCustomsInformationDetails(customsInformationDetailsTemp)
													}}
													onBlur={(e) => {
														validateAlphaIfPresent(
															e.target.value,
															setError,
															`isoCountryCode${index}`
														)
														validateFieldLengthIfPresent(
															e.target.value,
															setError,
															`isoCountryCode${index}`,
															null,
															null,
															2
														)
													}}
													aria-invalid={hasError(`isoCountryCode${index}`, error)}
													onFocus={(e) => {
														removeError(e, setError)
													}}
													error={error && error[`isoCountryCode${index}`]
														? t(error[`isoCountryCode${index}`], { ns: 'errors' })
														: ''}
												/>
											</div>
										{/* <div
											className='col-6 col-lg-2 form-item form-item--text'
											data-module='molecules/form-item/FormItem'
										>
											<label className='form-item__label'>
												{t('CAPTURE_AWB.ISO_CNTRY_CODE')}
											</label>
											<input
												id={`isoCountryCode${index}`}
												type='text'
												className='form-item__field'
												maxLength='2'
												placeholder=''
												value={info.countryCode ? info.countryCode.toUpperCase() : ''}
												onChange={(e) => {
													let customsInformationDetailsTemp = [...customsInformationDetails] 
													const val = e.target.value
													customsInformationDetailsTemp[index].countryCode =
														val && val.trim() !== '' ? val.toUpperCase() : val
													setCustomsInformationDetails(customsInformationDetailsTemp)
												}}
												onBlur={(e) => {
													validateAlphaIfPresent(
														e.target.value,
														setError,
														`isoCountryCode${index}`
													)
													validateFieldLengthIfPresent(
														e.target.value,
														setError,
														`isoCountryCode${index}`,
														null,
														null,
														2
													)
												}}
												aria-invalid={hasError(`isoCountryCode${index}`, error)}
												onFocus={(e) => {
													removeError(e, setError)
												}}
											/>
											<span className='form-item__error'>
												{error && error[`isoCountryCode${index}`]
													? t(error[`isoCountryCode${index}`], { ns: 'errors' })
													: ''}
											</span>
										</div> */}

											<div
												className={`form-group ${hasError(`informationID${index}`, error) ? "red-border" : ""
													}`}
											>
												<CommonInput
													id={`informationID${index}`}
													type='text'						
													maxLength='3'
													label={t('CAPTURE_AWB.INFO_ID')}
													value={info.informationId ? info.informationId?.toUpperCase() : ''}
													onChange={(e) => {
														let customsInformationDetailsTemp = [...customsInformationDetails]
														customsInformationDetailsTemp[index].informationId = e
															.target.value
															? e.target.value.split(' ').join('')
															: ''
														setCustomsInformationDetails(customsInformationDetailsTemp)
													}}
													onBlur={(e) => {
														validateAlphaIfPresent(
															e.target.value,
															setError,
															`informationID${index}`
														)
														validateFieldLengthIfPresent(
															e.target.value,
															setError,
															`informationID${index}`,
															null,
															null,
															3
														)
													}}
													aria-invalid={hasError(`informationID${index}`, error)}
													onFocus={(e) => {
														removeError(e, setError)
													}}
													error={error && error[`informationID${index}`]
														? t(error[`informationID${index}`], { ns: 'errors' })
														: ''}
												/>
											</div>

										{/* <div
											className='col-6 col-lg-2 form-item form-item--text'
											data-module='molecules/form-item/FormItem'
										>
											<label className='form-item__label'>
												{t('CAPTURE_AWB.INFO_ID')}
											</label>
											<input
												id={`informationID${index}`}
												type='text'
												className='form-item__field'
												maxLength='3'
												placeholder=''
												value={info.informationId ? info.informationId.toUpperCase() : ''}
												onChange={(e) => {
													let customsInformationDetailsTemp = [...customsInformationDetails] 
													customsInformationDetailsTemp[index].informationId = e
														.target.value
														? e.target.value.split(' ').join('')
														: ''
													setCustomsInformationDetails(customsInformationDetailsTemp)
												}}
												onBlur={(e) => {
													validateAlphaIfPresent(
														e.target.value,
														setError,
														`informationID${index}`
													)
													validateFieldLengthIfPresent(
														e.target.value,
														setError,
														`informationID${index}`,
														null,
														null,
														3
													)
												}}
												aria-invalid={hasError(`informationID${index}`, error)}
												onFocus={(e) => {
													removeError(e, setError)
												}}
											/>
											<span className='form-item__error'>
												{error && error[`informationID${index}`]
													? t(error[`informationID${index}`], { ns: 'errors' })
													: ''}
											</span>
										</div> */}
									</div>	

									<div className='shipping-deparr-row'>

											<div
												className={`form-group ${hasError(`customsInfoId${index}`, error) ? "red-border" : ""
													}`}
											>
												<CommonInput
													id={`customsInfoId${index}`}
													type='text'
													label={t('CAPTURE_AWB.CUST_INFO_ID')}
													maxLength='2'
													value={info.customsInformationId ? info.customsInformationId?.toUpperCase() : ''}
													onChange={(e) => {
														let customsInformationDetailsTemp = [...customsInformationDetails]
														customsInformationDetailsTemp[
															index
														].customsInformationId = e.target.value
																? e.target.value.split(' ').join('')
																: ''
														setCustomsInformationDetails(customsInformationDetailsTemp)
													}}
													onBlur={(e) => {
														validateAlphaIfPresent(
															e.target.value,
															setError,
															`customsInfoId${index}`
														)
														validateFieldLengthIfPresent(
															e.target.value,
															setError,
															`customsInfoId${index}`,
															2,
															1,
															null
														)
													}}
													aria-invalid={hasError(`customsInfoId${index}`, error)}
													onFocus={(e) => {
														removeError(e, setError)
													}}
													error={error && error[`customsInfoId${index}`]
														? t(error[`customsInfoId${index}`], { ns: 'errors' })
														: ''}
												/>
											</div>
										{/* <div
											className='col-12 col-lg-3 form-item form-item--text'
											data-module='molecules/form-item/FormItem'
										>
											<label className='form-item__label'>
												{t('CAPTURE_AWB.CUST_INFO_ID')} 
											</label>
											<input
												id={`customsInfoId${index}`}
												type='text'
												className='form-item__field'
												maxLength='2'
												value={info.customsInformationId ? info.customsInformationId.toUpperCase() : ''}
												onChange={(e) => {
													let customsInformationDetailsTemp = [...customsInformationDetails] 
													customsInformationDetailsTemp[
														index
													].customsInformationId = e.target.value
														? e.target.value.split(' ').join('')
														: ''
														setCustomsInformationDetails(customsInformationDetailsTemp)
												}}
												onBlur={(e) => {
													validateAlphaIfPresent(
														e.target.value,
														setError,
														`customsInfoId${index}`
													)
													validateFieldLengthIfPresent(
														e.target.value,
														setError,
														`customsInfoId${index}`,
														2,
														1,
														null
													)
												}}
												aria-invalid={hasError(`customsInfoId${index}`, error)}
												onFocus={(e) => {
													removeError(e, setError)
												}}
											/>
											<span className='form-item__error'>
												{error && error[`customsInfoId${index}`]
													? t(error[`customsInfoId${index}`], { ns: 'errors' })
													: ''}
											</span>
										</div> */}

											<div
												className={`form-group ${hasError(`suppCustomsInfo${index}`, error) ? "red-border" : ""
													}`}
											>
												<CommonInput
													id={`suppCustomsInfo${index}`}
													type='text'
													label={t('CAPTURE_AWB.SUP_INFO_ID')}
													maxLength='35'
													value={info.supplementaryCustomsInformation ? info.supplementaryCustomsInformation?.toUpperCase() : ''}
													onChange={(e) => {
														let customsInformationDetailsTemp = [...customsInformationDetails]
														customsInformationDetailsTemp[
															index
														].supplementaryCustomsInformation = e.target.value
														setCustomsInformationDetails(customsInformationDetailsTemp)
													}}
													onBlur={(e) => {
														validateSuppleCusInfoIfPresent(
															e.target.value,
															setError,
															`suppCustomsInfo${index}`
														)
													}}
													aria-invalid={hasError(
														`suppCustomsInfo${index}`,
														error
													)}
													onFocus={(e) => {
														removeError(e, setError)
													}}
													error={error && error[`suppCustomsInfo${index}`]
														? t(error[`suppCustomsInfo${index}`], { ns: 'errors' })
														: ''}
												/>
											</div>

										{/* <div
											className='col-12 col-lg-4 form-item form-item--text'
											data-module='molecules/form-item/FormItem'
										>
											<label className='form-item__label'>
												{t('CAPTURE_AWB.SUP_INFO_ID')}
											</label>
											<input
												id={`suppCustomsInfo${index}`}
												type='text'
												className='form-item__field sup-info'
												maxLength='35'
												value={info.supplementaryCustomsInformation ? info.supplementaryCustomsInformation.toUpperCase() : ''}
												onChange={(e) => {
													let customsInformationDetailsTemp = [...customsInformationDetails] 
													customsInformationDetailsTemp[
														index
													].supplementaryCustomsInformation = e.target.value
													setCustomsInformationDetails(customsInformationDetailsTemp)
												}}
												onBlur={(e) => {
													validateSuppleCusInfoIfPresent(
														e.target.value,
														setError,
														`suppCustomsInfo${index}`
													)
												}}
												aria-invalid={hasError(
													`suppCustomsInfo${index}`,
													error
												)}
												onFocus={(e) => {
													removeError(e, setError)
												}}
											/>
											<span className='form-item__error'>
												{error && error[`suppCustomsInfo${index}`]
													? t(error[`suppCustomsInfo${index}`], {
															ns: 'errors',
													  })
													: ''}
											</span>
										</div> */}
									</div>	
										{customsInformationDetails?.length > 1 && (
												<div className='delete-section delete-button ml-auto mt-auto' onClick={(e) => handleDeleteAction(e, index)}>
													<img src={deleteIcon} alt="Trash" title="Trash" id='Trash-icon' />
													<span>{t("COMMON.REMOVE")}</span>
												</div>		
										)}
									</div>
								))
							) : (
								<div></div>
							)}
					<div className='portal-row'>

						<button
							className='add-account-btn'
							style={{ background: 'transparent' }}
							onClick={handleAddCustomsInfo}
						>
							<img
								src={plusIcon}
								alt='Add surcharge'
								title='Add surcharge'
							/>
							<span className='add-account-btn'>{t('CAPTURE_AWB.ADD_CUST_INFO')}</span>
						</button>

						{/* <button
										className='link'
										style={{ background: 'transparent' }}
										onClick={handleAddCustomsInfo}
									>
										<span className='pt-1'>
											{t('CAPTURE_AWB.ADD_CUST_INFO')}
										</span>
									</button> */}
					</div>		
						</div>
					</div>		
		</div>
	)
}

export default CustomsDetails
